import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  PageEyebrowLink,
  PageHeader,
  Input,
  Button,
  Skeleton,
} from "@/components/ui";
import { ContainerHeader, FormRoles, RoleDataTable } from "@/components/common";
import { useFetchRolesQuery } from "@/hooks";

export function Roles() {
  const { t } = useTranslation();

  const [search, setSearch] = useState<string>("");
  // SPEC-NAV-01 §5: `search` is part of the query key, so the list refetches
  // on its own. The `setTimeout(refetch)` this page carried is gone.
  const { data: positionData, isLoading: isLoadingPosition } =
    useFetchRolesQuery({ search });

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow={
            <PageEyebrowLink to="/permissions">
              Equipe &amp; acessos
            </PageEyebrowLink>
          }
          title={t("LABEL.roles")}
          lede="Os cargos da equipe, usados para agrupar quem faz o quê na clínica."
          actions={
            <FormRoles>
              <Button variant="petrol" size="lg" className="px-5">
                {t("LABEL.new")}
              </Button>
            </FormRoles>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar cargos"
            placeholder={t("LABEL.search")}
            showError={false}
          />
        </ContainerHeader>
      </div>
      <div className="space-y-2">
        {!positionData || isLoadingPosition ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <RoleDataTable data={positionData} />
        )}
      </div>
    </section>
  );
}
